<template>
  <div>
    <div class="flex-sb" style="align-items: center;">
      <div>
        <p style="font-size: 18px;">上海市房屋拆迁中建筑物建安重置清单单价清册修编历史</p>
      </div>
      <div>
        <el-button icon="el-icon-plus" @click="showAddModal" size="small" type="primary" v-if="canManagement">新增</el-button>
      </div>
    </div>
    <el-row>
      <div class="mb-32">
        <div
          v-for="(item, index) in inventoryData"
          @mouseover="showDeleteButton($event, index)"
          @mouseout="hideDeleteButton($event, index)"
          @click="detail($event, item.id)"
          class="item-hover"
          :key="item.id"
        >
          <div class="flex-sb" style="align-items: center;">
            <div style="margin-top: 16px;margin-bottom: 16px;">
              <p class="item-title">{{item.name}}（{{dateFormat(item.date)}}）</p>
            </div>
            <div style="margin-right: 32px;">
              <el-button v-if="canManagement && item.isShowDeleteButton" @click.stop="deleteConfirm($event, item.id)" size="small">删除</el-button>
            </div>
          </div>
          <el-row>
            <el-col :span="6">
              <div style="height: 18px;">
                <img src="../assets/u53.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;总第{{item.version}}期
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="height: 18px;">
                <img src="../assets/u55.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;时点：{{item.date}}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="height: 18px;">
                <img src="../assets/u132.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;清单：{{item.listingCount}}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="height: 18px;">
                <img src="../assets/u138.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;标准房：{{item.standardRoomCount}}
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="5">
              <div style="height: 18px;">
                <img src="../assets/u144.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;安全文明措施费率：{{item.safetyRate}}%
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <div style="height: 18px;">
                <img src="../assets/u116.png" alt="" class="icon-size" align="absmiddle">
                <div style="font-size: 14px; display: inline-block; height: 18px; line-height: 18px;" class="icon-text">
                  &nbsp;&nbsp;增值税率：{{item.addedValueTaxRate}}%
                </div>
              </div>
            </el-col> -->
          </el-row>
          <div class="divide-line"></div>
        </div>
      </div>
      <div class="flex-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="pageForm.page"
          :page-size="pageForm.pageSize"
          layout="prev, pager, next"
          :total="pageForm.total"
        ></el-pagination>
      </div>
    </el-row>
    <el-dialog :visible.sync="addDialogShow" width="90%" :close-on-press-escape="false" :close-on-click-modal="false">
      <div slot="title" class="flex-center dialog-title">
        修编
      </div>
      <el-form :model="addForm" label-width="160px" ref="addForm" :rules="addFormRules">
        <div class="flex">
          <div style="flex-grow: 1; width: 50%;">
            <el-form-item label="版本名称" prop="name">
              <el-input v-model="addForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </div>
          <div style="flex-grow: 1; width: 25%;">
            <el-form-item label="总第" prop="version" class="version">
              <el-input v-model="addForm.version" autocomplete="off" style="width: 100%;">
                <template slot="append">期</template>
              </el-input>
            </el-form-item>
          </div>
          <div style="flex-grow: 1; width: 25%;">
            <el-form-item label="时点" prop="date">
              <el-date-picker
                format="yyyy-MM"
                value-format="yyyy-MM"
                v-model="addForm.date"
                style="width: 100%;"
                type="month">
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <!-- <div class="flex">
          <div style="width: 60%;" class="flex">
            <div style="width: 50%;">
              <el-form-item label="安全文明措施费率(%)" prop="safetyRate">
                <el-input-number v-model="addForm.safetyRate" :precision="2" :step="0.01" :min="0" :max="100" autocomplete="off" style="width:100%;">
                </el-input-number>
              </el-form-item>
            </div>
            <div style="width: 50%;">
              <el-form-item label="增值税率(%)" prop="addedValueTaxRate">
                <el-input-number v-model="addForm.addedValueTaxRate" :precision="2" :step="0.01" :min="0" :max="100" autocomplete="off" style="width:100%;">
                </el-input-number>
              </el-form-item>
            </div>
          </div>
          <div style="width: 40%;">
            <el-form-item label="时点" prop="date">
              <el-date-picker
                format="yyyy-MM"
                value-format="yyyy-MM"
                v-model="addForm.date"
                style="width: 60%;"
                type="month">
              </el-date-picker>
            </el-form-item>
          </div>
        </div> -->
        <div class="flex">
          <div style="width: 60%;">
            <el-form-item label="选择文件" prop="fileUrl">
              <div style="width:70%;display: inline-block">
                <el-input :disabled="true" v-model="addForm.fileUrl" style="width: 100%;margin-right: 36px;"></el-input>
              </div>
              <div style="width:30%;display: inline-block;" align="right">
                <el-upload
                  accept=".xls,.XLSX"
                  :show-file-list="false"
                  style="display: inline-block"
                  class="upload-demo"
                  :on-success="uploadSuccess"
                  :action="uploadUrl"
                  :data="uploadParams">
                  <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
              </div>
            </el-form-item>
          </div>
          <div style="width: 40%;">
            <div style="display: inline-block; margin-left: 120px;">
              获取导入文件格式请点击
              <el-button size="small" @click="downLoadTemplate">下载模板</el-button>
            </div>
          </div>
        </div>
        <div>
          <el-form-item label="清单单价清册说明" prop="description_price"></el-form-item>
          <vue-ueditor-wrap v-model="addForm.description_price" :config="myConfig" style="margin-left:160px"></vue-ueditor-wrap>
          <el-form-item label="清单计量规则说明" prop="description_rule"></el-form-item>
          <vue-ueditor-wrap v-model="addForm.description_rule" :config="myConfig" style="margin-left:160px"></vue-ueditor-wrap>
          <el-form-item label="清单清册编制说明" prop="description_prepare"></el-form-item>
          <vue-ueditor-wrap v-model="addForm.description_prepare" :config="myConfig" style="margin-left:160px"></vue-ueditor-wrap>
        </div>
      </el-form>
      <div slot="footer" class="flex-center">
        <span style="position: absolute; left: 10px; line-height: 36px; color: red; font-size: 13px;">
          * 导入后，系统将自动根据导入的文件，<span style="font-size: 16px;">整体</span>生成最新版本
        </span>
        <el-button type="primary" size="medium" @click="saveListRecordValidate">确定</el-button>
        <el-button @click="hideAddDialog" size="medium">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Schema from 'async-validator'
import VueUeditorWrap from 'vue-ueditor-wrap'
export default {
  components: {
    VueUeditorWrap
  },
  created () {
    this.uploadUrl = this.$http.defaults.baseURL + '/upload/excel'
    this.myConfig.serverUrl = `${this.$http.defaults.baseURL}/upload/uEditorUpload`
    this.getData()
    this.initAddForm()
    this.uploadParams.appkey = this.$oneitfarm.getAppkey()
    this.uploadParams.channel = this.$oneitfarm.getChannel()
    this.uploadParams.token = this.$oneitfarm.getToken()
  },
  data () {
    return {
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: '100%',
        maximumWords: 100000,
        toolbars: [[
          'source', '|', 'undo', 'redo', '|',
          'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
          'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
          'customstyle', 'paragraph', '|', 'fontfamily', 'fontsize', '|',
          'directionalityltr', 'directionalityrtl', 'indent', '|',
          'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
          'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
          'map', 'gmap', 'insertframe', 'webapp', 'pagebreak', 'template', 'background', '|',
          'horizontal', 'date', 'time', 'spechars', 'snapscreen', 'wordimage', '|',
          'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
          'print', 'preview', 'searchreplace', 'drafts'
        ]],
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // serverUrl: 'http://35.201.165.105:8000/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: process.env.BASE_URL + 'UEditor/'
      },
      uploadUrl: '',
      pageForm: {
        pageSize: 20,
        total: 1,
        page: 1
      },
      addDialogShow: false,
      addForm: {},
      uploadParams: {
        appkey: '',
        channel: '',
        token: ''
      },
      addFormRules: {
        name: [
          { required: true, message: '请输入版本名称', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请上传文件', trigger: 'blur' }
        ],
        version: [
          { required: true, message: '请输入期数', trigger: 'blur' }
          // { required: true, message: '请输入期数', trigger: 'change' }
        ],
        // safetyRate: [
        //   { required: true, type: 'number', message: '请输入安全文明措施费率', trigger: 'blur' }
        // ],
        // addedValueTaxRate: [
        //   { required: true, type: 'number', message: '请输入增值税率', trigger: 'blur' }
        // ],
        description_price: [
          { required: true, message: '清单单价清册说明', trigger: 'blur' }
        ],
        description_rule: [
          { required: true, message: '清单计量规则说明', trigger: 'blur' }
        ],
        description_prepare: [
          { required: true, message: '清单清册编制说明', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请输入时点', trigger: 'change' }
        ]
      },
      filedMap: {
        name: '版本名称',
        version: '期数',
        fileUrl: '文件',
        // safetyRate: '安全文明措施费率',
        // addedValueTaxRate: '增值税率',
        description_price: '清单单价清册说明',
        description_rule: '清单计量规则说明',
        description_prepare: '清单清册编制说明',
        date: '时点'
      },
      inventoryData: [],
      nextVersion: ''
    }
  },
  computed: {
    canManagement () {
      return this.$oneitfarm.hasRole('list.management')
    }
  },
  methods: {
    dateFormat (date) {
      let temp = date.replace('-', '.')
      return temp
    },
    initAddForm () {
      const addForm = {
        fileUrl: '',
        name: '上海房屋拆迁中建筑物建安重置清单单价清册',
        version: '',
        safetyRate: undefined,
        addedValueTaxRate: undefined,
        description_price: '',
        description_rule: '',
        description_prepare: '',
        date: ''
      }
      addForm.version = this.nextVersion + ''
      this.addForm = JSON.parse(JSON.stringify(addForm))
    },
    hideAddDialog () {
      this.addDialogShow = false
      this.$refs['addForm'].resetFields()
    },
    deleteConfirm (event, id) {
      this.$confirm('此操作不可恢复，确定删除当前版本？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.deleteListRecord(id)
      }).catch(() => {
      })
    },
    detail (event, detailId) {
      window.open('./#/detail/inventoryListDetail/' + detailId)
    },
    saveListRecordValidate () {
      // this.$refs['addForm'].validateField(['version'])
      var descriptor = this.addFormRules
      var validator = new Schema(descriptor)
      validator.validate(this.addForm, (errors, fields) => {
        if (errors) {
          const items = []
          Object.keys(fields).forEach((key) => {
            items.push(this.filedMap[key])
          })
          const msg = items.join('，')
          this.$confirm(`请输入：${msg}`, '提示', {
            confirmButtonText: '确定',
            center: true,
            showCancelButton: false
          }).then(() => {
          }).catch(() => {
          })
        } else {
          this.saveListRecord()
        }
        // validation passed
      })
    },
    async saveListRecord () {
      await this.addListRecord()
    },
    async addListRecord () {
      let response = (await this.$http.post('/list_record/add', this.addForm)).data
      if (response && Number.parseInt(response.ret) === 1) {
        this.$message.success('新增成功')
        this.getData()
        this.hideAddDialog()
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async getData () {
      let response = (await this.$http.post('/list_record/all', {
        page: this.pageForm.page,
        limit: this.pageForm.limit,
        filter: {
          isDelete: 0
        },
        order: 'order by id desc'
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        let responseData = response.data
        let total = Number.parseInt(responseData.total)
        this.pageForm.total = total
        let originalData = responseData.items
        originalData.map(item => {
          item.isShowDeleteButton = false
        })
        if (total !== 0) {
          this.nextVersion = Number.parseInt(originalData[0].version > this.nextVersion ? originalData[0].version : this.nextVersion) + 1
        }
        this.inventoryData = originalData
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    async deleteListRecord (id) {
      let response = (await this.$http.post('/list_record/delete', {
        id: id
      })).data
      if (response && Number.parseInt(response.ret) === 1) {
        this.$message.success('删除成功')
        this.getData()
      } else {
        this.$message.error({
          message: response.msg
        })
      }
    },
    uploadSuccess (response, file, fileList) {
      const ret = response.ret
      switch (ret) {
        case 1: {
          this.$message.success('上传成功')
          this.addForm.fileUrl = response.data
          break
        }
        default: {
          this.$confirm(response.msg, '提示', {
            confirmButtonText: '确定',
            center: true,
            showCancelButton: false
          }).then(() => {
          }).catch(() => {
          })
          break
        }
      }
    },
    showAddModal () {
      this.initAddForm()
      this.addDialogShow = true
    },
    handleCurrentChange (page) {
      this.getData()
    },
    showDeleteButton (event, index) {
      this.inventoryData[index].isShowDeleteButton = true
    },
    hideDeleteButton (event, index) {
      this.inventoryData[index].isShowDeleteButton = false
    },
    downLoadTemplate () {
      const appkey = this.$oneitfarm.getAppkey()
      const token = this.$oneitfarm.getToken()
      const channel = this.$oneitfarm.getChannel()
      window.open(`${this.$http.defaults.baseURL}/list_record/template/?appkey=${appkey}&token=${token}&channel=${channel}`)
    }
  }
}
</script>
<style scoped>
.divide-line {
  margin-top: 16px;
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
}
.item-hover:hover {
  cursor: pointer;
}
.item-title {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #434343;
}
.dialog-title {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: rgb(107, 107, 107);
}
.icon-text {
  font-family: 'MicrosoftYaHei', 'Microsoft YaHei';
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  color: #949494;
}
</style>
